<template>
  <div v-if="transaction._bankAccount" class="t-body flex-column" :class="{custom: config.privatePaymentHtml}">
    <div class="t-row" v-if="transaction && transaction.type === 'deposit' && !config.privatePaymentHtml">
      <div class="t-header">
        Para Yatırma
      </div>
      <div class="t-content">
        <p>Lütfen kendi adınıza olan hesap ile aşağıda belirtilen <b>{{transaction._bankAccount.name}}</b> alıcı isimli hesaba <b>{{transaction.amount.original |money}}</b> havale işlemi gerçekleştirin.</p>
        <p>Yatırımınızdan sonra ödemeyi gerçekleştirdim butonuna tıklayarak talep verebilirsiniz.</p>
        <hr>
        <div class="form-group">
          <label for="bankAccountNumber" class="col-form-label">IBAN Numarası</label>
          <b-input-group>
            <input id="bankAccountNumber" readonly type="text" class="form-control" :value="transaction._bankAccount.iban"/>
            <template v-slot:append>
              <b-button variant="success" @click="copyContent('bankAccountNumber')">
                <i class="bx bx-copy-alt"></i>
              </b-button>
            </template>
          </b-input-group>
        </div>
        <hr>
        <div class="alert alert-info">İşlem kontrol edildikten sonra bakiyenize yansıyacaktır.</div>
        <div class="text-center">
          <button class="btn btn-primary" @click="$bvModal.show('odeme-modal')">Ödemeyi Gerçekleştirdim</button>
        </div>
      </div>
      </div>
    <div v-else class="t-row paysystem">
      <div class="d-flex align-items-center justify-content-between">
       <div style="padding-top:20px">
         <p>Lütfen kendi adınıza olan banka hesabı ile aşağıda belirtilen <b>{{renderAccountName(transaction._bankAccount.name)}}</b> alıcı isimli hesaba <b>{{transaction.amount.original |money}}</b> yatırım işlemi gerçekleştirin.</p>
         <p>Yatırımınızdan sonra ödemeyi gerçekleştirdim butonuna tıklayarak talep verebilirsiniz.</p>
       </div>
      </div>
      <div class="t-content">
        <div class="form-group">
          <label for="bankAccountNumber" class="col-form-label">Hesap Numarası</label>
          <b-input-group>
            <input id="bankAccountNumber" readonly type="text" class="form-control" :value="transaction._bankAccount.iban"/>
            <template v-slot:append>
              <b-button variant="light" @click="copyContent('bankAccountNumber')">
                <i class="bx bx-copy-alt"></i> Kopyala
              </b-button>
            </template>
          </b-input-group>
        </div>
        <div class="alert alert-warning">İşlem kontrol edildikten sonra bakiyenize yansıyacaktır.</div>
        <div class="text-center">
          <button class="btn btn-success" @click="$bvModal.show('odeme-modal')">Ödemeyi Gerçekleştirdim</button>
        </div>
      </div>
    </div>
    <a class="mt-2 cursor-pointer" @click="goBack">Siteye geri dön</a>

    <b-modal id="odeme-modal" hide-footer title="Ödemeyi gerçekleştirdim">
      <div role="tablist">
        <div class="alert alert-success">
          İşleminiz kısa süre içerisinde onaylanacaktır. Teşekkür ederiz.
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {getTransaction} from "@/api/transaction";
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      transaction: null
    }
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
    }),
  },
  methods: {
    copyContent(element) {
      const copyText = document.getElementById(element);
      copyText.select();
      document.execCommand("copy");
    },
    renderAccountName(name) {
      let n = "";
      const split = name.split(" ");
      for(let i = 0; i < split.length; i++) {
        n += split[i].charAt(0) + ".....";
      }
      return n;
    },
    goBack() {
      window.history.go(-1);
      return false;
    }
  },
  mounted() {
    this.loading = true;
    getTransaction(this.$route.params.transactionId).then((response) => {
      if(response.data.data.type === "deposit") {
        this.transaction = response.data.data;
      }
    })
  }
}
</script>
<style lang="scss" >
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap');
.t-body.custom {
  background: #FFF !important;
  font-family: 'Roboto', sans-serif;
  b, strong {
    color: #143756;
  }
  #bankAccountNumber {
    background: #d9e4ef;
    border-color: #d9e4ef;
    color: #143756;
    font-weight: 600;
  }
}
.paysystem {
  background: transparent !important;
  border: 0 !important;
}
body{
  background: #f3f3f3 !important;
  color: #000;
}
.t-row{
  width:500px;
  max-width: 100%;
  border: 1px solid #e2e2e2;
  border-radius:8px;
  background: #FFF;
}
.t-body {
  width: 100%;
  height:100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.t-content {
  padding:1.5em;
}
.t-header {
  padding: 1em 1.5em;
  border-bottom: 1px solid #e2e2e2;
  background : #efefef;
}
.modal-content {
  background-color: #ffffff;
  border: 1px solid #ffffff;
}
.modal-header {
  background-color: #EEEFEF;
  border-color: #EEEFEF;
}
.modal-title {
  color: #000;
}
#bankAccountNumber {
  background: #efefef;
  border-color: #efefef;
  color: #5a5a5a;
}
</style>
